import React from 'react'

import TextArea from '../../../core/components/TextArea'
import { Element } from '../../lib/Element'
import { Answer } from '../../lib/types'

interface TextElementQuestionProps {
  element: Element
  onChange?: (answer: Answer) => void
}

/**
 * Editor component for TextElement
 */
const TextElementQuestion: React.FC<TextElementQuestionProps> = ({ element, onChange }) => {
  const [value, setValue] = React.useState<string>('') //TODO get current value

  const handleOnChange = (newValue: string) => {
    setValue(newValue)
    onChange?.({ answer: newValue })
  }

  const hasAttemptedSubmit = false // TODO

  const getError = () => {
    if (hasAttemptedSubmit) {
      if (element.mandatory && !value) {
        return 'This field is required' // TODO Translate
      }
    }
    return undefined
  }

  return (
    <TextArea
      hideLabel
      label={element.label}
      mandatory={element.mandatory}
      placeholder={'Add your question'} // TODO: Translate
      value={value}
      onChange={handleOnChange}
      // readonly={!onChange}
      error={getError()}
      minRows={element.getParam('rows')} // LongTextElement uses this param optionally, but it's not used by TextElement
    />
  )
}

export default TextElementQuestion
